import { Injectable }     from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot }    from '@angular/router';
import { AuthService } from './auth.service';
import { AppHelperService } from './app-helper.service';
import { environment } from 'environments/environment';


@Injectable()
export class AuthenticatedRoutesGuard  {
    
    constructor(
        private authService: AuthService, 
        private router: Router,
        private appHelperService: AppHelperService){
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) : boolean | Promise<boolean> {
        //for desktop app 
        if(environment.isDesktopApp ){
            this.authService.isUserAuthenticationChecked = true;

            //if current (from) url is launch-page, pass route
            if( this.router.url.includes('/launch-page') || this.router.url.includes('/teacher-dashboard') || this.router.url.includes('/learner-dashboard')){
                return true;
            }

            //if next url is not launch-page, send it to launch page
            if(!state.url.includes('/launch-page')){
                this.router.navigate(['/launch-page']);
                return false;
            }else{
                return true;
            }
        }
        return this.authService.getUserDataFromSession().then(userData => {
            return this.authService.checkGigyaAndServerSession().then(()=> {
                if(userData) {
                    return true;
                } else {
                    this.authService.rurl = window.location.pathname + window.location.search;
                    return false;
                }
            });
        });
    }
}